import { useEffect, useRef, useState } from "react"
import { Input } from "reactstrap"
import ShimmerScreen from "../../../Layouts/ShimmerScreen"
import ProductCardComponent from "../../ProductCard/ProductCardComponent"
import ProductCardPaymentComponent from "../../ProductCard/ProductCardPaymentComponent"
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent"
import { Spinner } from "react-bootstrap"
import "./RightPanelPaymentSection.scss"
import { navigateToView, SessionKeys } from "../../../../utils/AppUtils"
import { useDispatch, useSelector } from "react-redux"
import { couponCodeApply } from "../../../../redux/Cart/actions"
import _ from "lodash"
import { product } from "../../../../redux/product/actions"
import { useNavigate } from "react-router-dom"
import { isAndroid, isIOS } from "react-device-detect";

const RightPanelPaymentSection = (props) => {

    const {
        membershipCardInfo, paymentIntentInfo, showOnlyInfo, providerCardInfo, 
        productCardInfo, type, isLoggedIn, isCouponApplied, isRedeemApplied,
        setShouldRedeem, shouldRedeem, pidDirectCheckout, 
        setCouponCode, couponCode, couponMsg, setCouponMsg, 
        couponErrorMsg, setCouponErrorMsg, setCouponToApply
    } = props

    const dispatch = useDispatch()
    const couponRef = useRef()
    let navigate = useNavigate();

    const [couponInProcess, setCouponInProcess] = useState(false)
    const [redeemPoint, setRedeemPoint] = useState(0)
    const [redeemPrice, setRedeemPrice] = useState(0)
    const applyCouponRes = useSelector(state => state.carts.couponCodeApplyRes);

    useEffect(() => {
        // console.log('couponCodeApplyRes12:, ', applyCouponRes)
        if (!_.isEmpty(applyCouponRes)) {
            if (applyCouponRes.status === 'success') {
                let couponData = applyCouponRes.payload.data;
                setCouponMsg(applyCouponRes.payload.message)
            } else if (applyCouponRes.status === 'error') {
                setCouponMsg(applyCouponRes.error.message)
            }
            setCouponInProcess(false)
        }

    }, [applyCouponRes])

    useEffect(() => {
        if (!paymentIntentInfo.isLoading) {
            setRedeemPoint(paymentIntentInfo.redeemPoint)
            setRedeemPrice(paymentIntentInfo.redeemPrice)
        }
    }, [paymentIntentInfo])

    const applyCoupon = (isRemove) => {
        setCouponMsg('')
        setCouponErrorMsg('')
        if (isRemove) {
            setCouponCode('')
            couponRef.current.value = ''
        } else {
            console.log('couponRef', couponRef.current.value)
            const couponCD = couponRef.current.value
            if (couponCD) {
                setCouponCode(couponCD)
                setCouponToApply(true)
                // setCouponInProcess(true)
                // let postData = {
                //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                //     coupon_code: couponCode,
                // }
                // if (pidDirectCheckout) {
                //     postData.product_id = pidDirectCheckout
                // }
                // if (isRemove) {
                //     postData.remove_coupon = isRemove;
                //     couponRef.current.value = "";
                // }
    
                // let reqObj = {
                //     module: 'applyCoupon',
                //     postData
                // }
    
                // dispatch(couponCodeApply(reqObj))
            } else {
                setCouponErrorMsg('Please enter coupon code.')
            }
        }
    }

    const navigateToDetail = (obj, btnAction) => {

        if ((isAndroid || isIOS) && (productCardInfo[0]?.isMobile || providerCardInfo?.isMobile)) {
        try {
            if (window.callbackHandler != undefined) {
                window.callbackHandler.postMessage(JSON.stringify(obj));
            }
            if (window.webkit != undefined) {
                if (window.webkit.messageHandlers.callbackHandler != undefined) {
                    window.webkit.messageHandlers.callbackHandler.postMessage(
                        JSON.stringify(obj)
                    );
                }
            }
        } catch (err) {
            console.log("error in sending message");
        }
        } else  {navigate(btnAction)}
    }

    const renderCouponSection = () => {
        return (
            <>
                <div className="coupon-section">
                    <div className="d-flex gap-4 justify-content-start align-items-start">
                        <div>
                            <div className="form-group">
                                <div className="input-text ">
                                    <div className="d-flex gap-2">
                                        <Input
                                            id="coupon_code"
                                            className="input__field"
                                            name="coupon_code"
                                            type="text"
                                            placeholder="Discount code"
                                            required
                                            autoComplete="off"
                                            disabled={paymentIntentInfo.isLoading || isCouponApplied}
                                            innerRef={couponRef}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <FormButtonComponent
                                btnName={
                                    couponInProcess ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            variant="primary"
                                        />
                                        : isCouponApplied ? "Remove" : "Apply"
                                }
                                leftIcon=""
                                btnAction={() => applyCoupon(isCouponApplied)}
                                isPrimary={false}
                                disabled={paymentIntentInfo.isLoading}
                                replaceClassName={'btn-form-comp w-100'}
                            />
                        </div>
                    </div>
                    <span style={{color:"red"}}>{couponErrorMsg}</span>
                    <span style={{color:"green"}}>{couponMsg}</span>
                </div>
            </>
        )
    }

    const renderRedeemSection = () => {
        return (
            <>
                <div className="coupon-section">
                    <div className="d-flex gap-4 justify-content-start align-items-start">
                        <div>
                            <div className="form-group">
                                <div className="input-text ">
                                    <div className="d-flex gap-2">
                                        <Input
                                            id="redeem_box"
                                            className="input__field redeem_box"
                                            name="redeem_box"
                                            type="checkbox"
                                            placeholder="Discount code"
                                            required
                                            autoComplete="off"
                                            disabled={paymentIntentInfo.isLoading}
                                            // innerRef={couponRef}
                                            onChange={(e) => {
                                                setShouldRedeem(e.target.checked)
                                            }}
                                            checked={shouldRedeem}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="">
                        Redeem {redeemPoint} Reward Point{redeemPoint > 1 ? 's' : ''} 
                        &nbsp;(Equivalent to CA ${redeemPrice})
                        </div>
                    </div>
                    {/* <span>{couponMsg}</span> */}
                </div>
            </>
        )
    }


    const renderProviderPanel = () => {
        const obj = {
            type: 'service',
            method: 'navigate-to-detail-page',
            obj: providerCardInfo
        }
        return (
            <>
                <ProductCardComponent
                    title={providerCardInfo.title}
                    logoAltText={providerCardInfo.logoAltText}
                    logoURL={providerCardInfo.logoURL}
                    bannerURL={providerCardInfo.bannerURL}
                    description=""
                    tagsArray={providerCardInfo.tagsArray}
                    bannerAction={() => navigateToDetail(obj, navigateToView({
                        product_type: 'service',
                        service_code: providerCardInfo.code,
                        product_id: providerCardInfo.id
                    }))}
                    descAction={() => navigateToDetail(obj, navigateToView({
                        product_type: 'service',
                        service_code: providerCardInfo.code,
                        product_id: providerCardInfo.id
                    }))}
                    footerLineComp={() => { }}
                    showHeader={true}
                    showBody={false}
                    showFooter={false}
                    showProviderIcon={true}
                    lastKey={false}
                    showPlayButton={false}
                    showProgress={false}
                    cardClassName="product-card-subscription col-xl-12"
                    leftBtnIcon='/images/arrow-right.svg'
                    rightBtnIcon=""
                    isLoading={providerCardInfo.isLoading}
                />
                {
                    providerCardInfo.isLoading ?
                        <div className="price-label">
                            <ShimmerScreen
                                case="rect"
                                width="5rem"
                                height="1rem"
                            />
                        </div>
                        :
                        <>
                            {providerCardInfo.isRecurring ?
                                <div className="price-label">
                                    ${providerCardInfo.price}, billed monthly
                                </div> :
                                <div className="price-label">
                                    ${providerCardInfo.price}
                                </div>
                            }
                        </>
                }
                <div className="order-total-info">
                    <div className="totalt-text">
                        {
                            paymentIntentInfo.isLoading ?
                                <>
                                    <div className="totl-heading">
                                        Total
                                        <span className="taxes">
                                            <ShimmerScreen
                                                case="rect"
                                                height="1rem"
                                                width="2rem"
                                            />
                                        </span>
                                    </div>
                                    <div className="price-box">
                                        <ShimmerScreen
                                            case="rect"
                                            height="2rem"
                                            width="5rem"
                                        />
                                    </div>
                                </>
                                :
                                <>
                                    <div className="totl-heading">
                                        Total
                                        <span className="taxes">Incl. of taxes (CA ${paymentIntentInfo.taxes})</span>
                                    </div>
                                    <div className="price-box">CA ${paymentIntentInfo.total}</div>
                                </>
                        }
                    </div>
                </div>
            </>
        )
    }

    const renderMembershipPanel = () => {
        return (
            <>
                <ProductCardComponent
                    title={membershipCardInfo.title}
                    logoAltText={membershipCardInfo.logoAltText}
                    logoURL={membershipCardInfo.logoURL}
                    bannerURL={membershipCardInfo.bannerURL}
                    description=""
                    tagsArray={membershipCardInfo.tagsArray}
                    // bannerAction={() => navigateToView(productCardInfo)}
                    // descAction={() => navigateToView(productCardInfo)}
                    footerLineComp={() => { }}
                    showHeader={true}
                    showBody={false}
                    showFooter={false}
                    showProviderIcon={true}
                    lastKey={false}
                    showPlayButton={false}
                    showProgress={false}
                    cardClassName="product-card-subscription col-xl-12"
                    leftBtnIcon='/images/arrow-right.svg'
                    rightBtnIcon=""
                    isLoading={membershipCardInfo.isLoading}
                    membershipCard={true}
                />
                {
                    membershipCardInfo.isLoading ?
                        <div className="price-label">
                            <ShimmerScreen
                                case="rect"
                                width="5rem"
                                height="1rem"
                            />
                        </div>
                        :
                        <div className="price-label">
                            {/* ${membershipCardInfo.price}, billed annually */}
                            {membershipCardInfo.priceText}
                        </div>
                }
                <div className="order-total-info">
                    <div className="totalt-text">
                        {
                            paymentIntentInfo.isLoading ?
                                <>
                                    <div className="totl-heading">
                                        Total
                                        <span className="taxes">
                                            <ShimmerScreen
                                                case="rect"
                                                height="1rem"
                                                width="2rem"
                                            />
                                        </span>
                                    </div>
                                    <div className="price-box">
                                        <ShimmerScreen
                                            case="rect"
                                            height="2rem"
                                            width="5rem"
                                        />
                                    </div>
                                </>
                                :
                                <>
                                    <div className="totl-heading">
                                        Total
                                        <span className="taxes">Incl. of taxes (CA ${paymentIntentInfo.taxes})</span>
                                    </div>
                                    <div className="price-box">CA ${paymentIntentInfo.total}</div>
                                </>
                        }
                    </div>
                </div>
            </>
        )
    }

    const renderProductCart = () => {
        let obj= {
            type: productCardInfo[0].productType,
            method: 'navigate-to-detail-page',
            obj: productCardInfo[0]
        }
        return (
            <>
                <ProductCardComponent
                    title={productCardInfo[0].title}
                    logoAltText={productCardInfo[0].logoAltText}
                    logoURL={productCardInfo[0].logoURL}
                    bannerURL={productCardInfo[0].bannerURL}
                    description=""
                    tagsArray={productCardInfo[0].tagsArray}
                    bannerAction={() => navigateToDetail(obj, productCardInfo[0]?.btnAction)}
                    descAction={() => navigateToDetail(obj, productCardInfo[0]?.descAction)}
                    // descAction={() =>  { 
                    //     if ((isAndroid || isIOS) && productCardInfo[0]?.isMobile) {
                    //     try {
                    //         if (window.callbackHandler != undefined) {
                    //             window.callbackHandler.postMessage(JSON.stringify(obj));
                    //         }
                    //         if (window.webkit != undefined) {
                    //             if (window.webkit.messageHandlers.callbackHandler != undefined) {
                    //                 window.webkit.messageHandlers.callbackHandler.postMessage(
                    //                     JSON.stringify(obj)
                    //                 );
                    //             }
                    //         }
                    //     } catch (err) {
                    //         console.log("error in sending message");
                    //     }
                    // } else { navigate(productCardInfo[0]?.descAction)} 
                    // }}
                    footerLineComp={() => { }}
                    showHeader={true}
                    showBody={false}
                    showFooter={false}
                    showProviderIcon={true}
                    lastKey={false}
                    showPlayButton={false}
                    showProgress={false}
                    cardClassName="product-card-subscription col-12"
                    leftBtnIcon='/images/arrow-right.svg'
                    rightBtnIcon=""
                    isLoading={false}
                    showLikeMenu={false}
                    isBundle={productCardInfo[0].isBundle}
                    bundles={productCardInfo[0].bundles}
                    priceInfo={productCardInfo[0].priceInfo}
                />
                <div className="price-label text-align-right">
                    {productCardInfo[0].price}
                </div>
                
            </>
        )
    }

    const renderProductPanel = () => {
        return (
            <>
                {
                    productCardInfo.length === 1 ?
                        renderProductCart()
                        :
                        <div className="courses-pack-section">
                        {productCardInfo.map((p, i) => {
                            return (
                            <ProductCardPaymentComponent key={`prod-pay-i-${i + 1}`} {...p} product={p} />
                            )
                        })}
                        </div>
                }
                {
                    isLoggedIn &&
                    <>
                        <div className="order-total-info">
                            {renderCouponSection()}
                        </div>
                        {
                            (paymentIntentInfo.showRedeemPoint ||
                            redeemPoint) ?
                            <div className="order-total-info mt-0">
                                {renderRedeemSection()}
                            </div> : ""
                        }
                    </>
                }
                <div className="order-total-info mt-4">
                    {
                        ((isCouponApplied || isRedeemApplied) && !paymentIntentInfo.isLoading) ?
                            <div className="d-flex gap-2 justify-content-between mb-2">
                                <div>
                                    Discount
                                </div>
                                <div>- CA ${paymentIntentInfo.discount}</div>
                            </div>
                            :
                            ""
                    }
                    <div className="totalt-text">
                        {
                            paymentIntentInfo.isLoading ?
                                <>
                                    <div className="totl-heading">
                                        Total
                                        <span className="taxes">
                                            <ShimmerScreen
                                                case="rect"
                                                height="1rem"
                                                width="2.5rem"
                                            />
                                        </span>
                                    </div>
                                    <div className="price-box">
                                        <ShimmerScreen
                                            case="rect"
                                            height="2rem"
                                            width="5rem"
                                        />
                                    </div>
                                </>
                                :
                                <>
                                    <div className="totl-heading">
                                        Total
                                        <span className="taxes">Incl. of taxes (CA ${paymentIntentInfo.taxes})</span>
                                    </div>
                                    <div className="price-box">CA ${paymentIntentInfo.total}</div>
                                </>
                        }
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            {
                type === 'subscription' ?
                    renderMembershipPanel()
                    :
                    type === 'coaching' ?
                        renderProviderPanel()
                    :
                        renderProductPanel()
            }
        </>
    )
}

export default RightPanelPaymentSection